














































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import type { User } from '@/models/user';
import type { EmailNotificationInterval } from '@/models/emailNotificationInterval';
import { userSettingWebservice } from '@/webservices/userSetting';

@Component({
    name: 'Notifications',
})
export default class Notifications extends Vue {
    @Getter('account/userInfo') private userInfo: User;
    @Action('account/getUserInfo') private getUserInfo;

    private emailNotificationIntervals = new Array<EmailNotificationInterval>();

    private selectedEmailNotificationInterval: EmailNotificationInterval = {} as EmailNotificationInterval;

    private mounted() {
        this.getAllEmailNotificationIntervals();
        this.selectedEmailNotificationInterval = this.userInfo.settings.email_notification_interval;
    }

    private async getAllEmailNotificationIntervals() {
        this.emailNotificationIntervals = await userSettingWebservice.getAllEmailNotificationIntervals();
    }

    private async toggleEmailNotifications() {
        await userSettingWebservice.toggleEmailNotifications();
        this.getUserInfo();
    }

    private async updateUserEmailNotificationIntervals() {
        await userSettingWebservice.updateUserEmailNotificationIntervals(this.selectedEmailNotificationInterval);
        this.getUserInfo();
    }
}
